import { Attributes, ModelBase } from '@singularsystems/neo-core';
import { TradeOrderStatus } from '../Enums/TradeOrderStatus';

export default class TradeOrderLookup extends ModelBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly tradeOrderId: number = 0;
    public readonly rawImportFileId: number = 0;
    public readonly messageTypeCode: string = "";
    public readonly messageTypeName: string = "";
    public readonly typeCode: string = "";
    public readonly tradeDescription: string = "";
    public readonly stockBrokerCode: string = "";
    public readonly stockBrokerName: string = "";
    public readonly fundCode: string = "";
    public readonly fundName: string = "";
    public readonly bulkedInvestorCode: string = "";
    public readonly bulkedInvestorName: string = "";
    public readonly productCode: string = "";
    public readonly productName: string = "";
    public readonly accountNumber: string = "";
    public readonly referenceNumber: string = "";

    @Attributes.Nullable()
    @Attributes.Float()
    public readonly percent: number | null = null;

    @Attributes.Nullable()
    public readonly units: number | null = null;

    public readonly currency: string = "";

    public amount: number = 0;

    public confirmedAmount: number | null = null;

    @Attributes.Date()
    public readonly cycleDate: Date = new Date();

    public readonly modeCode: string = "";
    public readonly fundReference: string = "";
    public readonly tradeOrderStatusName: string = "";
    public readonly tradeOrderStatusId: TradeOrderStatus = TradeOrderStatus.Pending;
    public readonly staticServiceProviderFileGroupingId: number = 0;

    @Attributes.Display("Service Provider")
    public staticServiceProviderFileGroupingName: string = "";

    public note: string | null = null;

    public fileDescriptorId: number | null = null;
}